import { Link } from 'react-router-dom';

/** Mark (three lines + chevron, flat accent — same motif as /icons/logo.svg) and the "b4b" wordmark. */
export function LogoMark({ className = 'h-7 w-7' }: { className?: string }) {
  return (
    <svg viewBox="0 0 28 28" aria-hidden="true" className={className} fill="currentColor">
      <rect x="2" y="5" width="18" height="3" rx="1.5" />
      <rect x="2" y="12.5" width="13" height="3" rx="1.5" />
      <rect x="2" y="20" width="18" height="3" rx="1.5" />
      <path d="M18.6 9.5 23.1 14l-4.5 4.5-1.6-1.6L19.9 14l-2.9-2.9z" />
    </svg>
  );
}

export default function LandingLogo({ to = '/' }: { to?: string }) {
  return (
    <Link to={to} className="flex items-center gap-2.5 text-accent" aria-label="b4b">
      <LogoMark />
      <span className="text-lg font-bold tracking-tight text-neutral-900 dark:text-slate-100 sm:text-xl">
        b4b
      </span>
    </Link>
  );
}
